const binding = { modules: {}, dataActions: {} };

    (binding.modules['home-page-banner'] = {
        c: () => require('partner/modules/home-page-banner/home-page-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'home-page-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/home-page-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|home-page-banner|home-page-banner'] = {
                c: () => require('partner/modules/home-page-banner/home-page-banner.view.tsx'),
                cn: '__local__-__local__-home-page-banner'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };